module.exports = __webpack_public_path__ + "static/media/properties.d7ffe4f9.jpg";